
export const BIG_WIN_MULTIPLIER = 3.5;
export const BIG_WIN_MIN_CREDITS = 125000;

export const isBigWin = (itemPrice: number, sourcePrice?: number): boolean =>
  itemPrice >= BIG_WIN_MIN_CREDITS && (sourcePrice ? itemPrice > sourcePrice * BIG_WIN_MULTIPLIER : false);
